class AtlCartEnhancements extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    const sync = () => {
      document.querySelectorAll('#cart-drawer .cart-drawer__summary,.cart-page__summary').forEach(summary => {
        if (!summary.querySelector('[data-atl-notes]')) { const content = this.querySelector('template').content.cloneNode(true); content.firstElementChild.dataset.atlNotes = ''; summary.prepend(content); }
      });
      document.querySelectorAll('#cart-drawer .cart-drawer--empty').forEach(empty => {
        const link = empty.querySelector('a.button'); if (link && this.dataset.shopUrl) { if (link.getAttribute('href') !== this.dataset.shopUrl) link.setAttribute('href',this.dataset.shopUrl); if (link.textContent !== this.dataset.shopLabel) link.textContent = this.dataset.shopLabel; }
        const heading = empty.querySelector('#cart-drawer-heading');
        if (heading && this.dataset.emptyLabel && heading.textContent.trim() !== this.dataset.emptyLabel) heading.textContent = this.dataset.emptyLabel;
        const items = empty.querySelector('.cart-drawer__items');
        if (items && !items.querySelector('[data-atl-notes]')) { const content = this.querySelector('template').content.cloneNode(true); content.firstElementChild.dataset.atlNotes = ''; items.append(content); }

      });
    };
    let scheduled = false;
    this.observer = new MutationObserver(() => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; sync(); }); });
    this.observer.observe(document.querySelector('#cart-drawer') || document.body,{childList:true,subtree:true});
    const page = document.querySelector('.cart-page')?.closest('.shopify-section'); if (page) this.observer.observe(page,{childList:true,subtree:true});
    sync();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('atl-cart-enhancements')) customElements.define('atl-cart-enhancements',AtlCartEnhancements);
